var alertTriggerControls = {
	limits: "Limits",
	upperLimit: "Oberes Limit",
	upperLimitPlaceholder: "Oberer Limit Kurs",
	lowerLimit: "Unteres Limit",
	lowerLimitPlaceholder: "Unterer Limit Kurs",
	deleteBtn: "Löschen",
	cancelBtn: "Abbrechen",
	saveBtn: "Ok",
	validationErrors: {
		upperLimit: {
			invalidInput: "Ungültige Eingabe. Bsp.: 123.456",
			priceMismatch: "Das obere Limit muss über dem letzten Kurs liegen"
		},
		lowerLimit: {
			invalidInput: "Ungültige Eingabe. Bsp.: 123.456",
			priceMismatch: "Das untere Limit muss unter dem letzten Kurs liegen"
		}
	}
};
var de = {
	alertTriggerControls: alertTriggerControls
};

export { alertTriggerControls, de as default };
